import * as XLSX from "xlsx";

function formatSubmittedAt(value) {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString("pt-BR");
  } catch {
    return String(value);
  }
}

function sanitizeFileName(name) {
  return String(name || "questionario")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-_]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 80);
}

/**
 * Gera e baixa arquivo Excel a partir do payload de exportação do backend.
 * @param {Object} exportData - resposta de GET /questionnaires/:id/report/export
 * @param {string} [suffix] - sufixo do arquivo (turma ou todas)
 */
export function downloadQuestionnaireExcel(exportData, suffix = "export") {
  const columns = exportData?.columns || [];
  const rows = exportData?.rows || [];

  if (!columns.length) {
    throw new Error("Nenhuma coluna disponível para exportação.");
  }

  const headers = columns.map((col) => col.header);
  const keys = columns.map((col) => col.key);

  const excelRows = rows.map((row) =>
    keys.map((key) => {
      if (key === "submitted_at") {
        return formatSubmittedAt(row[key]);
      }
      const value = row[key];
      if (value === undefined || value === null) return "";
      return value;
    })
  );

  const ws = XLSX.utils.aoa_to_sheet([headers, ...excelRows]);

  ws["!cols"] = headers.map((header, colIdx) => {
    const maxLen = Math.max(
      String(header || "").length,
      ...excelRows.map((row) => String(row[colIdx] || "").length)
    );
    return { wch: Math.min(Math.max(maxLen + 2, 12), 60) };
  });

  const wb = XLSX.utils.book_new();
  const sheetName = rows.length > 0 ? "Respostas" : "Sem respostas";
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));

  const now = new Date();
  const dateStr = now.toISOString().slice(0, 10);
  const timeStr = now.toTimeString().slice(0, 5).replace(":", "h");
  const title = sanitizeFileName(exportData?.questionnaire?.title || "questionario");
  const fileName = `${title}_${suffix}_${dateStr}_${timeStr}.xlsx`;

  XLSX.writeFile(wb, fileName);
}
